/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Context } from 'koa'

/**
 * Default key generator for Koa.
 * `ctx.ip` respects X-Forwarded-For when `app.proxy = true` is set.
 */
export const extractIp = (ctx: Context): string =>
  ctx.ip ?? ctx.socket?.remoteAddress ?? 'unknown'

/**
 * User-scoped key: `user:<id>` when `ctx.state.user` is set by auth middleware,
 * otherwise falls back to `ip:<address>`.
 */
export const buildUserKey = (ctx: Context): string => {
  const user = (ctx.state as any)?.user as Record<string, unknown> | undefined
  const userId: unknown = user?.['id'] ?? user?.['_id']
  if (userId != null) return `user:${String(userId)}`
  return `ip:${extractIp(ctx)}`
}
